import { computed } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

interface DraftState {
  drafts: Record<string, string>;
  attachments: Record<string, any>;
}

const initialState: DraftState = {
  drafts: {},
  attachments: {},
};

export const DraftStore = signalStore(
  { providedIn: 'root' },
  withState<DraftState>(initialState),
  withMethods((store) => ({
    saveDraft(channelId: string, text: string): void {
      patchState(store, (state) => ({
        drafts: { ...state.drafts, [channelId]: text },
      }));
    },

    getDraft(channelId: string): ReturnType<typeof computed<string>> {
      return computed(() => store.drafts()[channelId] ?? '');
    },

    clearDraft(channelId: string): void {
      patchState(store, (state) => {
        const drafts = { ...state.drafts };
        delete drafts[channelId];
        return { drafts };
      });
    },

    saveAttachment(channelId: string, attachment: any): void {
      patchState(store, (state) => ({
        attachments: { ...state.attachments, [channelId]: attachment },
      }));
    },

    getAttachment(channelId: string): ReturnType<typeof computed<any>> {
      return computed(() => store.attachments()[channelId] ?? null);
    },

    clearAttachment(channelId: string): void {
      patchState(store, (state) => {
        const attachments = { ...state.attachments };
        delete attachments[channelId];
        return { attachments };
      });
    },

    clearAll(): void {
      patchState(store, initialState);
    },
  })),
);
